import {decorate, inject, injectable} from '@yosmanyga/di';
import {AxiosInstance} from './Axios';

class PlayApi {
    constructor(private axios: AxiosInstance) {
    }

    createGame = async () => {
        await this.axios
            .withAuthentication()
            .withLanguage()
            .post('/v1/create-game');
    };

    playGame = async (request: string): Promise<Response> => {
        const {data} = await this.axios
            .withAuthentication()
            .withLanguage()
            .post('/v1/play-game', {
                request: request,
            });

        return data as Response;
    };

    restartGame = async () => {
        await this.axios
            .withAuthentication()
            .withPlatform()
            .withLanguage()
            .post('/v1/restart-game');
    };
}

decorate(injectable(), PlayApi);
decorate(inject(AxiosInstance), PlayApi, 0);

export type Response = {
    lines: string[],
    version: string,
    dead: boolean,
    won: boolean,
};

export {PlayApi};
